export const product = {
	/**
	* Gets the programmatic name of the entire locale, with the language,
	*	country and variant separated by underbars. The Language is always lower case,
	*	and country is always upper case. If the language is missing,
	*	the string will begin with an underscore character.
	*	If both the language and country fields are missing,
	*	this function will return the empty string,
	*	even if the variant field is filled in (you cannot have a locale with just a variant--
	*	the variant must accompany a valid language or country code). Examples: "en"
	*
	*/
    en: {
        product:'Product',
        product_information:'Product Information',
        product_id:'Product Id',
        product_onboarding:'Product Onboarding',
        add_product:'Add Product',
        edit_product:'Edit Product',
        product_name:'Product Name',
        product_category:'Product Category',
        product_type_id:"Product Type Id",
        product_code:"Product Code",
        oem_name:"OEM Name",
        oem_code:"OEM Code",
        vendor_model:"Vendor Model",
        vendor_name:"vendor Name",
        vendor_code:"vendor Code",
        device_profile_number:"Device Profile Number",
        status:'Status',
        delete_confrim_msg:"Are you sure you want to delete this product?"
    },

    ar: {
        product:'المنتج',
        product_information:'معلومات المنتج',
        product_id:'معرف المنتج',
        product_onboarding:'إعداد المنتج',
        add_product:'أضف منتج',
        edit_product:'تحرير المنتج',
        product_name:'اسم المنتج',
        product_type_id:"معرف نوع المنتج",
        product_code:"كود المنتج",
        oem_name:"اسم OEM",
        oem_code:"كود OEM",
        vendor_model:"نموذج البائع",
        vendor_name:"اسم البائع",
        vendor_code:"رمز البائع",
        device_profile_number:"رقم ملف تعريف الجهاز",
        status:'الحالة',
        delete_confrim_msg:"هل أنت متأكد أنك تريد حذف هذا المنتج؟"
    }
}
